import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {
  IS_AUTH,
  USER_INFO,
  ID_TOKEN,
  REFRESH_TOKEN
} from '../../../settings/constants';
import webStorage from '../../../utils/webStorageClient';
import { AUTHORIZATION_VERSION, sessionUserInfo } from 'utils/authUser';

const isAuthFromStorage: boolean = webStorage.get(IS_AUTH);
const userInfoFromStorage = webStorage.get(USER_INFO);
const validSession = !!isAuthFromStorage && !!webStorage.getToken()
  && userInfoFromStorage?.authorizationVersion === AUTHORIZATION_VERSION;

export interface AuthInterface {
  isAuth: boolean;
  userInfo: any;
  error: any;
}

const initialState: AuthInterface = {
  isAuth: validSession,
  userInfo: validSession ? userInfoFromStorage : {},
  error: {}
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,

  reducers: {
    actionLogin: (state,action: PayloadAction<any>) => {
      state.isAuth = action.payload?.isAuth;
      state.userInfo = action.payload?.isAuth
        ? sessionUserInfo(action.payload?.userInfo, action.payload?.accessToken, action.payload?.username)
        : {};
      webStorage.set(IS_AUTH, action.payload?.isAuth);
      webStorage.set(ID_TOKEN, action.payload?.id_token);
      webStorage.setToken(action.payload?.accessToken);
      webStorage.set(REFRESH_TOKEN, action.payload?.refresh_token);
      webStorage.set(USER_INFO, state.userInfo);
    },

    actionLogout: state => {
      state.isAuth = false;
      state.userInfo = {};
      state.error = {};
      webStorage.removeAll();
    }
  },

  extraReducers: {}
});

export const { actionLogin, actionLogout } = authSlice.actions;
export default authSlice.reducer;
